// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch___DQDl","slider":"Switch_slider__2JR0S","round":"Switch_round__dv26-"};